import React from 'react'
import PropTypes from 'prop-types'
import StatusReportContextProvider from './statusReportContext'

function StatusReportProvider ({ children, config, variant }) {
  return (
    <StatusReportContextProvider config={config} variant={variant}>
      {children}
    </StatusReportContextProvider>
  )
}

StatusReportProvider.propTypes = {
  children: PropTypes.node,
  config: PropTypes.shape({
    filtersAt: PropTypes.arrayOf(PropTypes.number)
  }),
  variant: PropTypes.oneOf(['default', 'board'])
}

StatusReportProvider.defaultProps = {
  variant: 'default'
}

export default StatusReportProvider
